import { FC, useRef } from 'react'

import cx from 'clsx'
import { useOpenMenu } from 'hooks/useOpenMenu'
import { useDemandElasticityDemo } from 'modules/demandElasticity/hooks/useDemandElasticityDemo'
import { Loader, LoaderTypes } from 'ui/Loader'

import classes from './DemandElasticityDashboard.module.scss'

interface DemandElasticityDashboardProps {
  className?: string
}

export const DemandElasticityDashboard: FC<DemandElasticityDashboardProps> = ({ className }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const openMenu = useOpenMenu((state) => state.open)
  const { hasError, isLoading } = useDemandElasticityDemo(containerRef)

  return (
    <div className={cx(classes.wrap, className, { [classes.open]: openMenu })}>
      <div className={classes.scroll}>
        <div className={classes.cont}>
          {isLoading && <Loader className={classes.loader} type={LoaderTypes.SpinnerCenter} />}
          {hasError && <div className={classes.error}>Не удалось загрузить демо «Эластичность спроса»</div>}
          <div className={classes.root} ref={containerRef} />
        </div>
      </div>
    </div>
  )
}
